'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = require('react-bootstrap');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A status label that shows an text description and an icon, e.g.:
 * 	enabled  [^]
 * 	disabled [ ]
 */
var Status = function (_React$Component) {
	_inherits(Status, _React$Component);

	function Status(props) {
		_classCallCheck(this, Status);

		var _this = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this._handleClick = _this._handleClick.bind(_this);
		_this._renderStatus = _this._renderStatus.bind(_this);
		_this.status = {
			enabled: {
				icon: 'checkmark-circle',
				label: _this.intl.formatMsg('enabled')
			},
			disabled: {
				icon: 'lock',
				label: _this.intl.formatMsg('disabled')
			},
			error: {
				icon: 'warning',
				label: _this.intl.formatMsg('error')
			},
			success: {
				icon: 'checkmark-circle',
				label: _this.intl.formatMsg('success')
			},
			warning: {
				icon: 'warning',
				label: _this.intl.formatMsg('warning')
			},
			info: {
				icon: 'info',
				label: _this.intl.formatMsg('info')
			},
			awaiting: {
				icon: 'alarm',
				label: _this.intl.formatMsg('awaiting')
			}
		};
		return _this;
	}

	_createClass(Status, [{
		key: '_handleClick',
		value: function _handleClick(e) {
			e.preventDefault();
			var status = this.status[this.props.type];
			// It's wrong using label here (it's internationalised).
			//  Need to use basic status or switch to pass out the event in v5
			// also get rid of data - it's just passed here to be passed out again
			this.props.onClick(status && status.label, this.props.data);
		}
	}, {
		key: '_renderStatus',
		value: function _renderStatus() {
			var _this2 = this;

			var status = this.status[this.props.type];
			var icon = this.props.icon || status && ' gg icon-GG-' + status.icon;
			var label = this.props.label !== undefined ? this.props.label : status && status.label || undefined;
			var tabindex = this.props.tooltip || this.props.onClick ? '0' : undefined;

			if (this.props.onClick) {
				return _react2.default.createElement(
					'span',
					{
						tabIndex: tabindex,
						className: (0, _classnames2.default)('status', 'clickable', this.props.type),
						onKeyPress: function onKeyPress(e) {
							(0, _accessibilityUtils.OnActionKey)(e, _this2._handleClick);
						},
						onClick: this._handleClick
					},
					label,
					_react2.default.createElement(
						_reactBootstrap.Button,
						{
							tabIndex: -1,
							bsStyle: 'default',
							className: (0, _classnames2.default)('iconic', this.props.className)
						},
						_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: icon })
					)
				);
			} else {
				return _react2.default.createElement(
					'span',
					{ tabIndex: tabindex, className: (0, _classnames2.default)('status', this.props.type) },
					label,
					_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: icon })
				);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    tooltipPlacement = _props.tooltipPlacement,
			    tooltip = _props.tooltip;

			if (tooltip) {
				var tip = _react2.default.createElement(
					_reactBootstrap.Tooltip,
					{ id: 'tooltip' },
					tooltip
				);
				return _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ tabIndex: 0, placement: tooltipPlacement, overlay: tip },
					this._renderStatus()
				);
			}
			return this._renderStatus();
		}
	}]);

	return Status;
}(_react2.default.Component);

Status.propTypes = {
	type: _propTypes2.default.oneOf(['enabled', 'disabled', 'error', 'success', 'warning', 'info', 'awaiting']),
	className: _propTypes2.default.string,
	tooltip: _propTypes2.default.string,
	tooltipPlacement: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
	label: _propTypes2.default.string,
	icon: _propTypes2.default.string,
	onClick: _propTypes2.default.func,
	data: _propTypes2.default.string
};

Status.defaultProps = {
	className: '',
	tooltipPlacement: 'right'
};

var _default = (0, _reactIntl.injectIntl)(Status);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Status, 'Status', 'src/components/Status.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Status.jsx');
}();

;